/**
 * 中文翻译（zh-CN）
 *
 * 所有 UI 文本的单一真相源。按功能域分组。
 * 新增 key 时自动推导到 TranslationKey 联合类型。
 */

export default {
  // ===== 通用 =====
  "common.save": "保存",
  "common.cancel": "取消",
  "common.delete": "删除",
  "common.back": "返回",
  "common.settings": "设置",
  "common.deploy": "部署",
  "common.map": "地图",
  "common.test": "测试",
  "common.build": "构建",
  "common.clear": "清空",
  "common.unknown": "未知",
  "common.loading": "加载中",

  // ===== App =====
  "app.title": "战斗代码 BattleCode · v1.0.2-demo",

  // ===== 屏 0 首页 =====
  "home.title_line1": "承 刃 计 划",
  "home.title_line2": "PROJECT BLADE-BEARER",
  "home.world_bg_line1": "2019 战颅系统诞生；2023 核心文档封存，唯余《淬火假说》。",
  "home.world_bg_line2": "2028 承刃计划启动，LLM 承接新一代引擎。",
  "home.world_bg_line3": "铸剑阁锻造知识之剑，砺锋台于实战中淬火开刃。",
  "home.world_bg_line4": "从单智能体决策，演进至多智能体协同涌现。",
  "home.world_bg_line5": "你，接过前人铸就的利刃。",
  "home.poem_line1": "承战颅遗志 · 启群智之涌",
  "home.poem_line2": "锻代码为剑 · 淬战术为锋",
  "home.poem_line3": "铸剑非为战 · 共智拓新天",
  "home.poem_latin": "Ignis · Ferrum · Honor",
  "home.poem_subtext": "// 锻造链：图纸 → 锻造 → 开刃 → 持剑",
  "home.entry_forge_label": "铸剑于阁",
  "home.entry_forge_sub": "━━ ◇ ━━",
  "home.entry_sharpen_label": "砺锋于台",
  "home.entry_sharpen_sub": "━━ ◇ ━━",
  "home.entry_bear_label": "承刃而行",
  "home.entry_bear_sub": "━━ ◇ ━━",
  "home.entry_sandbox_label": "沙盘演兵",
  "home.entry_sandbox_sub": "━━ ◇ ━━",
  "home.entry_armory_label": "兵主殿",
  "home.entry_armory_sub": "━━ ◈ ━━",
  "home.nav_levels": "[关卡列表]",
  "home.nav_settings": "[设置]",
  "home.footer": "承刃计划 v7.0 · Pyodide · 纯浏览器内",

  // ===== 屏 1 项目列表 =====
  "project.home_btn": "首页 Home",
  "project.arena": "⚡ 竞技场 Arena",
  "project.sharpen_btn": "砺锋台 →",
  "project.settings_btn": "设置 Settings",
  "project.my_levels": "我的关卡",
  "project.arena_records": "Arena 战绩",
  "project.builtin_levels": "内置关卡",
  "project.tutorial_levels": "教学样例",
  "project.no_levels": "还没有关卡。",
  "project.go_builtin": "从内置关卡开始",
  "project.no_arena_records": "还没有 Arena 进化记录。",
  "project.go_arena": "进入 Arena 竞技场",
  "project.no_available": "暂无可用关卡。",
  "project.from_level": "从关卡开始",
  "project.from_level_desc": "选择一个关卡来创建新项目。关卡的地图、AI 和模板代码会自动配置。",
  "project.no_levels_modal": "没有可用关卡。",
  "project.or_blank": "或创建空白项目（不关联任何关卡）",
  "project.default_name": "我的首个机器人 MyFirstBots",
  "project.delete_title": "删除项目 Delete Project",
  "project.delete_body": "确定要删除这个项目吗？代码会丢失。",
  "project.unknown_level": "未知关卡 Unknown Level",
  "project.unknown_ai": "未知AI Unknown AI",
  "project.opponent_ai": "对手 AI",
  "project.commits": "提交 COMMITS",
  "project.created": "创建 CREATED",
  "project.enter_edit": "进入编辑",
  "project.arena_hint": "Arena 进化记录 · 点 DEPLOY 对战冠军 bot",
  "project.select_level_hint": "选择关卡 · 点 进入编辑 自动创建项目",
  "project.console_log_hint": "console log → prototype/logs/browser.log",
  "project.logo_sub": "战斗代码",

  // ===== 屏 2 编辑器 =====
  "editor.back_to_list": "← 返回 Back",
  "editor.project_list": "项目列表",
  "editor.deploy_btn": "提交出战 DEPLOY",
  "editor.save_btn": "保存 Save",
  "editor.console": "▌ 控制台 CONSOLE",
  "editor.control_output": "控制在输出",
  "editor.build_tab": "构建 BUILD",
  "editor.test_tab": "测试 TEST",
  "editor.deploy_tab": "部署 DEPLOY",
  "editor.clear_btn": "清空 Clear",
  "editor.console_placeholder": "点击 BUILD 编译查看输出；TEST 跑 preflight；DEPLOY 查 dry-run。结果会显示在这里。",
  "editor.map_panel": "地图 MAP",
  "editor.vibe_title": "VIBE CODING",
  "editor.vibe_subtitle": "人机协作编程",
  "editor.vibe_placeholder": "说人话 · 例如：\"遇到敌人就开火，没遇到就往中央走\"",
  "editor.generate_mode": "生成模式",
  "editor.optimize_mode": "基于现有代码优化",
  "editor.overwrite_mode": "覆盖重写",
  "editor.generate_btn": "生成代码 →",
  "editor.clear_vibe": "清空",
  "editor.generate_progress": "AI 生成进度",
  "editor.saved": "已保存",
  "editor.python_lang": "PYTHON",
  "editor.json_lang": "JSON",
  "editor.status_line": "Python 3.12 · UTF-8 · LF",
  "editor.pending_banner": "⚠ 待确认",
  "editor.reject_btn": "✕ 不接受",
  "editor.accept_btn": "✓ 接受",
  "editor.switch_back_tank": "已切回 Tank.py。可继续编辑或点 [生成代码] 调 Vibe AI。",
  "editor.cleared_msg": "已清空。点击 BUILD/TEST/DEPLOY 切换标签。",
  "editor.syntax_ok": "语法检查通过。可点 TEST 跑 preflight，或右下角 [提交出战 DEPLOY] 直接进战斗。",
  "editor.skip_compile": "跳过编译：v1.1.0 多文件支持即将上线",
  "editor.switch_to_tank": "切回 Tank.py 才能编译 / TEST / DEPLOY。",
  "editor.test_untested": "未跑过 TEST（可不跑直接 DEPLOY，但代码正确性无保障）",
  "editor.test_passed": "TEST 通过 ✓",
  "editor.test_failed": "TEST 失败 ✗",
  "editor.deploy_direct": "点右下角 [提交出战 DEPLOY] 直接进屏 4 战斗。",
  "editor.must_switch_tank": "只能在 Tank.py 上跑 preflight（Strategy.py/Config.json 是 v1.1.0 占位）。先切回 Tank.py。",
  "editor.preflight_start": "▶ TEST: 启动 preflight + 自动修复管道（最多 3 轮）…",
  "editor.generating": "⏳ 生成中 Generating...",
  "editor.project_not_found": "项目不存在",
  "editor.tank_py": "Tank.py",
  "editor.strategy_py": "Strategy.py",
  "editor.config_json": "Config.json",
  "editor.pyodide_loading": "⏳ 加载 Pyodide 运行时（首次约 3-5s）…",
  "editor.prompt_empty": "prompt 不能为空。点选择指令选 TIP 模板，或在文本框里描述战术。",
  "editor.generated_success": "生成成功。点 [✓ 接受] 落盘，或 [✕ 不接受] 撤销。",
  "editor.accepted_code": "已接受。代码已落盘，可继续修改或点 [TEST] 验证。",
  "editor.reverted_code": "已撤销。生成代码已丢弃，编辑器回到生成前状态。",
  "editor.vibe_failed": "✗ Vibe Generate 失败",
  "editor.deploy_blocked": "⚠ TEST 失败时 DEPLOY 会被拦截（状态机保护）",
  "editor.back_to_editor": "← 返回编辑器修改",
  "editor.go_battle": "→ 直接开战",
  "editor.engine_error": "✗ 引擎错误",
  "editor.pyodide_failed": "可能是 Pyodide 加载失败（首次约 3-5s，需要联网拉 CDN）。",
  "editor.retry_test": "重试 [TEST]；如持续失败请检查网络。",
  "editor.preflight_passed": "✓ 通过",
  "editor.preflight_failed": "✗ 失败",
  "editor.manual_fix": "▼ 请手动修改代码后重试 TEST",
  "editor.tip_filled": "已填入 TIP",
  "editor.new_player": "新手推荐 NEW PLAYER",
  "editor.prompt_cleared": "已清空 prompt",

  // ===== 屏 4 战斗 =====
  "battle.give_up": "← 退出推演",
  "battle.time": "时间 TIME",
  "battle.tick": "帧 TICK",
  "battle.speed": "速度 SPD",
  "battle.live": "● 推演进行中",
  "battle.done": "● 推演结束",
  "battle.standby": "● 待机 STANDBY",
  "battle.team_a_title": "蓝方 · 推演官",
  "battle.team_b_title": "红方 · 对手",
  "battle.tank_log": "推演日志",
  "battle.console_title": "▌ 控制台 CONSOLE",
  "battle.console_tab_all": "全部 ALL",
  "battle.console_tab_team_a": "A队 TEAM_A",
  "battle.console_tab_team_b": "B队 TEAM_B",
  "battle.console_tab_kill": "击杀 KILL",
  "battle.console_tab_error": "错误 ERR",
  "battle.console_empty": "等待战斗事件…",
  "battle.first_blood": "★ 首杀 FIRST BLOOD",
  "battle.ready_title": "倒计时 · FIGHT IN ",
  "battle.status_dead": "阵亡",
  "battle.status_cooldown": "冷却",
  "battle.status_aiming": "瞄准",
  "battle.status_moving": "移动",
  "battle.status_idle": "待命",
  "battle.action_idle": "待命",
  "battle.action_move": "移动",
  "battle.action_shoot": "开火",
  "battle.action_scan": "扫描",
  "battle.action_move_to": "移动 → ",
  "battle.give_up_title": "放弃战斗？",
  "battle.give_up_body": "当前战局将被记录为失败。",
  "battle.give_up_ok": "放弃",
  "battle.give_up_cancel": "继续战斗",
  "battle.expand_console": "展开 CONSOLE",
  "battle.collapse_console": "折叠 CONSOLE",
  "battle.console_lines": "lines",
  "battle.expand_detail": "展开详情",
  "battle.collapse_detail": "收起详情",
  "battle.waiting": "等待中",
  "battle.cooldown_ready": "就绪",

  // ===== 屏 4 Tooltip =====
  "tooltip.you_player": "你 · 玩家坦克 YOU",
  "tooltip.enemy_ai": "敌方 · AI 坦克 ENEMY",
  "tooltip.spawn": "出生点 SPAWN",
  "tooltip.cover": "掩体 COVER",
  "tooltip.obstacle": "障碍 OBSTACLE",
  "tooltip.unreachable": "不可达 UNREACHABLE",
  "tooltip.empty": "空地 EMPTY",
  "tooltip.supply_zone": "补给点 SUPPLY ZONE",
  "tooltip.team_a_you": "A · 你",
  "tooltip.team_b_ai": "B · AI(激进型)",
  "tooltip.team_a_player": "A · 玩家",
  "tooltip.team_b_ai_short": "B · AI",
  "tooltip.position": "位置",
  "tooltip.hp": "HP",
  "tooltip.cooldown": "冷却",
  "tooltip.action": "动作",
  "tooltip.range": "射程",
  "tooltip.blocks_move": "阻挡移动",
  "tooltip.blocks_vision": "阻挡视野",
  "tooltip.damage_reduction": "伤害减免",
  "tooltip.enter": "进入",
  "tooltip.blocks": "阻挡",
  "tooltip.yes": "是",
  "tooltip.no": "否",
  "tooltip.none": "无",
  "tooltip.at_start": "战斗开始时即占",
  "tooltip.range_chebyshev": "格(切比雪夫)",

  // ===== 屏 5 结果 =====
  "result.victory": "胜利",
  "result.defeat": "战败",
  "result.draw": "平局",
  "result.battle_result": "战斗结果",
  "result.key_events": "关键事件",
  "result.tactical_review": "战术复盘",
  "result.live_logs": "实时日志",
  "result.rematch": "重新对战",
  "result.modify_code": "修改代码",
  "result.back_hub": "返回主页",
  "result.after_action": "战后复盘",
  "result.aar_analyzing": "AAR 分析中...",
  "result.aar_error": "战术复盘生成失败，可重试或继续查看。",
  "result.radar_pos": "站位",
  "result.radar_prs": "施压",
  "result.radar_vis": "视野",
  "result.radar_sht": "射击",
  "result.radar_sur": "生存",
  "result.radar_tmp": "节奏",
  "result.kda": "击杀/死亡/助攻",
  "result.total_ticks": "总帧数",
  "result.duration": "战局时长",
  "result.final_hp": "终局血量",
  "result.final_hp_a": "终局HP(你)",
  "result.final_hp_b": "终局HP(AI)",
  "result.battle_analysis": "战况分析",
  "result.player_give_up": "玩家放弃战斗",
  "result.s_tick": "帧",
  "result.s_seconds": "秒",
  "result.floating_panel": "FLOATING PANEL",
  "result.mission_result": "任务结果",
  "result.tactical_advisor": "战术顾问",
  "result.tick": "帧",
  "result.grid": "网格",
  "result.rounds": "轮",
  "result.no_data": "（无数据）",
  "result.chat_placeholder": "提出后续问题…",
  "result.chat_limit_reached": "已达 3 轮上限，请回屏 2 修改代码后重试。",
  "result.chat_analyzing": "战术顾问分析中…",
  "result.coach_init": "士兵，我是 CS-07 战术顾问。最弱维度：{weakest}（{weakestScore}）；最优先：{strongest}（{strongestScore}）。你有 3 轮提问机会。",
  "result.coach_disconnected": "⚠️ 战术顾问失联：{error}",
  "result.quick_prompt_lose": "我为什么输了？",
  "result.quick_prompt_fix": "应该优先修复哪个逻辑？",
  "result.quick_prompt_aggressive": "如果我打得更激进会怎样？",

  // ===== 屏 6 设置 =====
  "settings.title": "设置 SETTINGS",
  "settings.back_btn": "← 返回 Back",
  "settings.llm_config": "LLM 配置",
  "settings.llm_hint": "用于屏 2 模态层（Vibe Coding）的自然语言 → 代码生成",
  "settings.api_key_label": "DeepSeek-coder API Key",
  "settings.api_key_current": "当前",
  "settings.api_key_configured": "（已配置）",
  "settings.api_key_unconfigured": "（未配置）",
  "settings.api_key_hint": "demo 阶段已预置一个共享 key，开箱即用；如需用自己的 key 覆盖，直接粘贴后保存即可。",
  "settings.save_key": "保存",
  "settings.daily_usage": "今日用量",
  "settings.engine_tuning": "引擎调优（高级）",
  "settings.expand": "展开",
  "settings.tick_rate": "Tick 频率",
  "settings.soft_timeout": "软超时",
  "settings.hard_timeout": "硬超时",
  "settings.evals_title": "Evals 评估",
  "settings.evals_hint": "跑 N 局 vs AI 对手，评估 bot 代码质量（Harness 自动化层 FR-C）",
  "settings.evals_select_level": "选择关卡",
  "settings.evals_select_placeholder": "-- 选择关卡 --",
  "settings.evals_start": "▶ 开始 Evals",
  "settings.evals_running": "跑炉中",
  "settings.evals_result_title": "评估结果",
  "settings.evals_win_rate": "胜率",
  "settings.evals_avg_survival": "平均存活 tick",
  "settings.evals_avg_damage": "平均伤害",
  "settings.evals_comment_header": "能力说明",
  "settings.evals_comment_density": "注释密度",
  "settings.evals_api_comments": "关键调用注释",
  "settings.evals_strategy": "策略签名",
  "settings.evals_no_history": "暂无评估记录",
  "settings.evals_cant_read": "无法读取关卡代码",
  "settings.evals_history": "历史评估记录",
  "settings.theme_title": "主题",
  "settings.theme_tactical": "Tactical（暗色）",
  "settings.theme_day": "Day（亮色）",
  "settings.language_title": "语言 Language",
  "settings.language_zh": "中文",
  "settings.language_en": "English",
  "settings.about_title": "关于",
  "settings.about_line1": "BattleCode Demo v1.0.0-demo",
  "settings.about_line2": "Pyodide + Web Worker + 30Hz 同步 tick",
  "settings.about_line3": "资源锁定：1 tank / 1 battle_easy / 1 ai_easy_aggressive",
  "settings.api_key_saved": "✓ 已保存到 localStorage（demo 阶段无后端中转）",

  // ===== 屏 7 地图编辑器 =====
  "map_editor.title": "地图编辑器 MAP EDITOR",
  "map_editor.editing": "编辑中",
  "map_editor.save": "保存",
  "map_editor.save_as": "另存为",
  "map_editor.undo": "撤销",
  "map_editor.redo": "重做",
  "map_editor.clear_all": "清空",
  "map_editor.export": "导出关卡",
  "map_editor.spawn_p1": "出生点 P1",
  "map_editor.spawn_p2": "出生点 P2",
  "map_editor.spawn_p1_label": "P1",
  "map_editor.spawn_p2_label": "P2",

  // ===== 屏 8 Arena =====
  "arena.title": "进化竞技场 EVOLUTION ARENA",
  "arena.idle": "空闲",
  "arena.battling": "对战中",
  "arena.mutating": "变异中",
  "arena.stopping": "停止中",
  "arena.done": "完成",
  "arena.ranking": "排行榜",
  "arena.battle_field": "战场",
  "arena.tournament_log": "锦标赛日志",
  "arena.code": "代码",
  "arena.config": "配置",
  "arena.start": "开始",
  "arena.stop": "停止",
  "arena.diff": "对比",
  "arena.save_level": "保存关卡",
  "arena.dual_replay": "双视角回放",
  "arena.trend": "趋势",
  "arena.start_prompt": "点击开始启动进化",
  "arena.battle": "局",
  "arena.error": "错误",
  "arena.waiting_start": "等待进化开始...",
  "arena.select_bot_hint": "选择一个 Bot 查看代码",
  "arena.gen_label": "第 {gen}/{total} 代",
  "arena.vs_gen0": "vs G0",
  "arena.winner_draw": "平局",
  "arena.winner_win": "{name} 胜",
  "arena.replay_btn": "▶ 回放",
  "arena.battle_vs": "⚡ {a} vs {b}",
  "arena.origin_seed": "种子",
  "arena.origin_elite": "精英",
  "arena.origin_mutation": "突变",
  "arena.record_format": "胜{wins} 负{losses} 平{draws}{vsG0}",

  // ===== 屏 8 Arena 日志 =====
  "arena.log_battle_pending": "[G{gen} · {num}/{total}] {a} vs {b} ...",
  "arena.log_battle_done": "[G{gen} · {num}] {a} vs {b} → {result} (T{ticks} · 观赏性 {spec})",
  "arena.log_gen_done": "[G{gen} 完成 · {level}] 最佳: {best} ({bestFit}) · 均: {avgFit} · vsG0: {vsG0}%",
  "arena.log_complete": "[完成] 冠军: {name} · 适应度: {fitness} · {battles} 场用时 {duration}s",
  "arena.log_error": "[错误] {msg}",
  "arena.log_fatal": "[致命] {msg}",
  "arena.log_mutate_start": "[突变] {name} → 分析中...",
  "arena.log_mutate_done": "[突变] {name} → ✓ {note}",
  "arena.log_mutate_fail": "[突变] {name} → ✗ 失败",
  "arena.log_auto_saved": "[AUTO-SAVED] G{gen} 冠军 → Arena 战绩",
  "arena.log_auto_save_failed": "[AUTO-SAVE FAILED] G{gen} 冠军",
  "arena.log_saved": "[SAVED] \"{name}\" → 屏 1「Arena 战绩」可玩 (id: {id})",
  "arena.log_save_err": "[SAVE_ERR] {msg}",

  // ===== 屏 8 Arena 弹窗 =====
  "arena.modal_trend_title": "进化趋势",
  "arena.modal_close": "关闭",
  "arena.modal_dual_title": "双视角回放 · G0 vs G{last}",
  "arena.modal_dual_label_a": "G0 · {name}",
  "arena.modal_dual_label_b": "G{last} · {name}",
  "arena.modal_play": "▶ 播放",
  "arena.modal_pause": "❚❚ 暂停",
  "arena.modal_reset": "↺ 重置",
  "arena.modal_diff_title": "代码对比",
  "arena.modal_diff_bot_a": "Bot A:",
  "arena.modal_diff_bot_b": "Bot B:",
  "arena.modal_diff_similarity": "相似度: {pct}%",
  "arena.modal_config_title": "竞技场配置",
  "arena.modal_config_generations": "世代数 (1-4)",
  "arena.modal_config_generations_hint": "每代对应一个关卡（空旷对决 → 掩体火力 → 战术坚守 → 侧翼突击）",
  "arena.modal_config_population": "种群数 (2-4)",
  "arena.modal_config_battles": "每对战斗数 (1-4)",
  "arena.modal_config_seed_mode": "种子模式",
  "arena.modal_config_seed_mixed": "混合 (内置 + LLM)",
  "arena.modal_config_seed_builtin": "AI 内置",
  "arena.modal_config_seed_llm": "LLM 生成",
  "arena.modal_config_level_rotation": "关卡旋转",
  "arena.modal_config_cancel": "取消",
  "arena.modal_config_apply": "应用",
  "arena.modal_save_title": "保存为可玩关卡",
  "arena.modal_save_body": "将冠军 bot <strong>{name}</strong> (适应度: {fitness}) 保存到屏 1「Arena 战绩」供后续对战。",
  "arena.modal_save_level_name": "关卡名称",
  "arena.modal_save_cancel": "取消",
  "arena.modal_save_save": "保存",

  // ===== 错误信息 =====
  "error.screen4_failed": "屏 4 启动失败",
  "error.screen7_failed": "屏 7 启动失败",
  "error.screen_render_failed": "屏渲染错误",

  // ===== 战斗日志 =====
  "battle.ai_kill_you": "AI 击毁 YOU",
  "battle.you_kill_ai": "YOU 击毁 AI",

  // ===== 屏 4 HP bar =====
  "battle.hit_pct": "HIT",
  "battle.mov": "MOV",
  "battle.sho": "SHO",
  "battle.dmg": "DMG",
} as const;
